import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Postrequestcall } from "../../request/Postrequest";
import { DELETE_USER_CERTIFICATION, SAVE_USER_CERTIFICATION } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import PromptModal from "../common/PromptModal";
export default function Addeducation({ educationData, onClose, onOpen, fetchEducation, id }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [education, setEducation] = useState({
    id: 0,
    school: "",
    study: ""
  });

  const [isPresent, setIsPresent] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [openPicker, setOpenPicker] = useState(null);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);

  const {
    TEXT_START_DATE = English?.Profile?.TEXT_START_DATE,
    TEXT_END_DATE = English?.Profile?.TEXT_END_DATE,
    TEXT_PRESENT = English?.Profile?.TEXT_PRESENT,
    TEXT_START_DATE_BEFORE_END = English?.Profile?.TEXT_START_DATE_BEFORE_END,
    TEXT_EDIT_EDUCATION = English?.Profile?.TEXT_EDIT_EDUCATION,
    TEXT_ADD_EDUCATION = English?.Profile?.TEXT_ADD_EDUCATION,
    TEXT_SCHOOL = English?.Profile?.TEXT_SCHOOL,
    TEXT_FIELD_OF_STUDY = English?.Profile?.TEXT_FIELD_OF_STUDY
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    setEducation({
      id: educationData?.id,
      school: educationData?.school,
      study: educationData?.study
    });
    setIsPresent(educationData?.present);
    setStartDate(
      educationData?.startDate == null || educationData?.id == 0
        ? null
        : dayjs(educationData?.startDate)
    );
    setEndDate(
      educationData?.endDate == null || educationData?.id == 0
        ? null
        : dayjs(educationData?.endDate)
    );
  }, [id]);

  const onSaveEducation = async () => {
    try {
      setIsLoading(true);
      if (
        !isPresent &&
        startDate &&
        endDate &&
        startDate.format("YYYY-MM-DD") > endDate.format("YYYY-MM-DD")
      ) {
        alert(TEXT_START_DATE_BEFORE_END);
        setIsLoading(false);
        return;
      }

      let getObj = {
        Id: education?.id,
        UserId: loginData?.userInformation?.UserId,
        School: education?.school,
        StartDate: startDate == null ? null : startDate.format("YYYY-MM-DD"),
        EndDate: isPresent ? null : endDate != null ? endDate.format("YYYY-MM-DD") : null,
        IsPresent: isPresent,
        FieldOfStudy: education?.study,
        ModifiedBy: loginData?.userInformation?.UserId
      };

      let getResponse = await Postrequestcall(
        SAVE_USER_CERTIFICATION,
        getObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        onClose();
        fetchEducation();
      }
      setIsModified(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("onSaveEducation-> Error While Saving User Trade Certification: ", error);
    }
  };

  const onDeleteEducation = async () => {
    try {
      setIsLoading(true);
      let getObj = [
        {
          Id: id,
          ModifiedBy: loginData?.userInformation?.UserId
        }
      ];
      let getResponse = await Postrequestcall(
        DELETE_USER_CERTIFICATION,
        getObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        onClose();
        fetchEducation();
      }
      setIsLoading(false);
    } catch (error) {
      console.log("onDeleteEducation-> Error While Deleting User Trade Certification: ", error);
      setIsLoading(false);
    }
  };

  const handleDateChange = (newValue, picker) => {
    if (picker === "start") {
      if (newValue && newValue.$y) {
        setStartDate(newValue); // Only set when a valid date is selected
      }
    } else if (picker === "end") {
      if (newValue && newValue.$y) {
        setEndDate(newValue);
      }
    }
    setIsModified(true);
  };

  const handlePickerClose = (picker) => {
    setOpenPicker(null);
    setTimeout(() => {
      if (picker === "start" && !startDate) {
        setStartDate(null); // Reset value if no valid selection is made
      }
      if (picker === "end" && !endDate) {
        setEndDate(null);
      }
      setOpenPicker(null);
      // document.activeElement?.blur();
    }, 100);
  };

  const handleTogglePicker = (e, picker) => {
    if (educationData?.from == "editEducation") {
      setIsModified(true);
    }
    e.stopPropagation();
    e.preventDefault();
    if (picker === "end" && isPresent) {
      setOpenPicker(null);
    } else {
      setOpenPicker((prev) => (prev === picker ? null : picker)); // Toggle between pickers
    }
    setIsModified(true);
  };

  const handleClear = (e, picker) => {
    setOpenPicker(null);
    e.preventDefault();
    e.stopPropagation();
    if (picker === "start") setStartDate(null);
    if (picker === "end") setEndDate(null);
  };

  const onInformationchange = async (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");

    if (educationData?.from == "editEducation") {
      setIsModified(true);
    }
    setEducation({
      ...education,
      [e.target.name]: inputValue
    });
    setIsModified(true);
  };

  const onPresentChange = (event) => {
    if (educationData?.from == "editEducation") {
      setIsModified(true);
    }
    setIsPresent(event.target.checked);
    setEndDate(null);
    setIsModified(true);
  };

  const isSaveDisabled =
    education?.school?.trim() === "" ||
    (!isPresent && startDate && endDate && startDate.isAfter(endDate));

  return (
    <>
      <Modal open={onOpen} closeAfterTransition>
        <Box className="user-modal-responsive">
          {isLoading ? (
            <Box sx={{ justifyContent: "center",  display: "flex", height: "400px" }}>
              <Loader />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}>
                <Typography sx={{ ml: 1,  fontWeight: "bold" }} variant="h5" >
                  {educationData?.from == "editEducation"
                    ? TEXT_EDIT_EDUCATION
                    : TEXT_ADD_EDUCATION}
                </Typography>
                <Stack direction={"row"}>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      if (isModified) {
                        setDiscardModalOpen(true);
                      } else {
                        onClose();
                      }
                    }}>
                    <CloseIcon />
                  </IconButton>
                  <IconButton
                    disabled={isSaveDisabled || isLoading}
                    color="primary"
                    onClick={() => onSaveEducation()}>
                    <SaveIcon />
                  </IconButton>
                  {educationData?.from == "editEducation" && (
                    <IconButton color="secondary" onClick={() => onDeleteEducation()}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Stack>
              </Box>

              <Stack  sx={{ gap: 2, marginTop: 2 }}>
                <TextField
                  fullWidth
                  label={`${TEXT_SCHOOL} *`}
                  variant="outlined"
                  name="school"
                  value={education?.school}
                  onChange={(e) => onInformationchange(e)}
                />
                <TextField
                  fullWidth
                  label={TEXT_FIELD_OF_STUDY}
                  variant="outlined"
                  name="study"
                  value={education?.study}
                  onChange={(e) => onInformationchange(e)}
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    enableAccessibleFieldDOMStructure={false}
                    autoFocus={false}
                    yearsPerRow={3}
                    label={TEXT_START_DATE}
                    value={startDate}
                    maxDate={dayjs()}
                    openTo="year"
                    views={["year", "month"]}
                    open={openPicker === "start"}
                    onChange={(newValue) => handleDateChange(newValue, "start")}
                    onClose={() => handlePickerClose("start")}
                    slotProps={{
                      textField: {
                        placeholder: "Month-Year",
                        fullWidth: true,
                        readOnly: true,
                        onClick: (e) => handleTogglePicker(e, "start"),
                        onFocus: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }
                      },
                      openPickerButton: {
                        onClick: (e) => handleTogglePicker(e, "start")
                      },
                      openPickerIcon: () => <CalendarTodayIcon />
                    }}
                  />

                  <DatePicker
                    enableAccessibleFieldDOMStructure={false}
                    label={TEXT_END_DATE}
                    disabled={isPresent}
                    value={endDate}
                    // maxDate={dayjs()}
                    minDate={startDate}
                    openTo="year"
                    views={["year", "month"]}
                    open={openPicker === "end"}
                    onChange={(newValue) => handleDateChange(newValue, "end")}
                    onClose={() => handlePickerClose("end")} // Use updated function
                    slotProps={{
                      textField: {
                        error: !isPresent && startDate && endDate && startDate.isAfter(endDate),
                        helperText:
                          !isPresent && startDate && endDate && startDate.isAfter(endDate)
                            ? "Start Date should be before the End Date"
                            : "",
                        disabled: isPresent,
                        placeholder: "Month-Year",
                        fullWidth: true,
                        readOnly: true,
                        onClick: (e) => handleTogglePicker(e, "end"),
                        onFocus: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }
                      },
                      openPickerButton: {
                        disabled: isPresent,
                        onClick: (e) => handleTogglePicker(e, "end")
                      },
                      openPickerIcon: () => <CalendarTodayIcon />
                    }}
                  />
                </LocalizationProvider>

                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isPresent}
                        onChange={onPresentChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label={TEXT_PRESENT}
                  />
                </FormGroup>
              </Stack>
            </>
          )}
        </Box>
      </Modal>
      {discardModalOpen && (
        <PromptModal
          isOpen={discardModalOpen}
          onClose={() => setDiscardModalOpen(false)}
          title={"Discard Changes"}
          desc={"Are you sure you want to discard the changes you made?"}
          redButtonText={"Discard"}
          onRedButtonClick={() => {
            setIsModified(false);
            setDiscardModalOpen(false);
            onClose();
          }}
        />
      )}
    </>
  );
}
